import axios from "axios"
if (localStorage.getItem("userAuthEtudiant")) {
  var userAuthEtudiant = JSON.parse(localStorage.getItem("userAuthEtudiant"))
  var token = userAuthEtudiant.user.api_token
}
export default axios.create({
  withCredentials: true,
  baseURL: `https://ismsf.etudiant.backcresus-institut.ovh/api/`,
  headers: {
    Authorization: `Bearer ${token}`,
    apipassword: "FGguKc8tTYKd6tLT",
    'X-Frame-Options' : "DENY"
  },
})
